<template>
  <v-form
    class="recovery-form"
    v-on:submit.prevent="recovery"
  >
    <v-text-field
      v-model="email"
      :error-messages="error['email']"
      label="Email"
      color="teal lighten-2"
      required
      outline
      clearable
      dark
      prepend-inner-icon="far fa-envelope fa-sm"
      class="theme round"
    />
    {{error['detail']}}
    <br>
        <div @click="recovery">
      <BottomPanel button-text="Recovery" />
      <v-dialog
        v-model="recoveryModal"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        class="recovery-dialog"
      >
        <div
          class="recovery-dialog__inner"
        >
          <div>
            <i class="recovery-dialog__icon far fa-envelope fa-8x"></i>
            <h1 class="recovery-dialog__title">We just sent you a recovery password in your inbox<br> to confirm once the recovery email has been entered</h1>
          </div>
        </div>

      </v-dialog>
    </div>
  </v-form>
</template>

<script>
  export default {
    name: 'RecoveryForm',
  }
</script>



<script>
  import BottomPanel from "./BottomPanel";
  import { mapGetters } from "vuex";
//  import {
//    RECOVERY_REQUEST
//  } from "../store/actions/recovery";

  export default {
    name: "RecoveryForm",
    components: {
      BottomPanel
    },
    data() {
      return {
        recoveryModal: false,
        form_title: "",
        email: "",
      };
    },
    computed: {
      ...mapGetters(
        'authentication', ['error'],
        )
    },
    methods: {
      recovery: function () {
        const {
          email,
        } = this;

        this.$store
          .dispatch('authentication/userRecovery', {
            email,
          })
         .then(() => {
           this.recoveryModal = true;
           setTimeout( () => {
             this.$router.push("/login");
           }, 3000)
         })
        //  .catch(() => {
        //  });
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.$store.dispatch('authentication/clearErrors');
      })
    }
  };
</script>

<style scoped>
  .recovery-dialog {

  }

  .recovery-dialog__inner {
    height: 100vh;
    background-color: #212121;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }

  .recovery-dialog__icon {
    position: relative;
    padding-bottom: 15px;
    margin-bottom: 15px;
    color: #4DB6AC;
  }

  .recovery-dialog__title {
    font-size: 30px;
    line-height: 35px;
  }

</style>
